module.exports = __webpack_public_path__ + "static/media/arrow-left.7ce8d0d4.svg";